<fieldset [ngClass]="{'flexResize':flexResize}">
    @if (label) {
    <label [raskRequired]="required">
        {{label}}
        @if (infoText) {
        <rask-info>
            <span [innerHTML]="infoText"></span>
        </rask-info>
        }
    </label>
    }
    <span [ngClass]="{ 'd-flex flex-row' : flexResize, 'height-fix': fillHeight }">
        <div class="box" [attr.tabIndex]="disabled ? null : '0'" (focus)="onFocusInput()" (blur)="onBlurInput()"
            [ngClass]="{'checked': value, 'partialChecked': partialChecked && !value}" id="{{aid}}"></div>
        @if (text) {
        <div class="text">{{text}}</div>
        }
    </span>
    @if (rule) {
    <rask-validation-message [rule]="rule"></rask-validation-message>
    }
</fieldset>